import type { FaireProductEntity } from "../../entity_types/product";

export const p_uc4zs2qxka: FaireProductEntity = {
  token: "p_uc4zs2qxka",
  type: "product",
  name: "The Petite Ruffled Modal Socks (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/c978d89b452d01fec7862f7c3c90fc065dcf0f5354ddda9aef8ebcadc5c64b2a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7a98fe8b1ee3fa773e69a67bd1f5b5c91fb2577ccbae7f44f8b8e0b3e558c35.jpeg",
    "https://cdn.faire.com/fastly/795a30ebfbc35f4281706475b574fab8fa924fa5400ad2246eb8e6e4af11356a.jpeg",
    "https://cdn.faire.com/fastly/ef0c79c7c5a13f9349d554f4055c27318c8e4a36a4191849bd3251e2e08f470d.jpeg",
    "https://cdn.faire.com/fastly/ce213ecaddaf5e0c8c4a96753982a7a2187c93526fc134b56852dbb2fcb805f2.jpeg",
    "https://cdn.faire.com/fastly/2693df16949e338bb3cc802288f8909f1d0d68b2ef4e8eceac05c3a781ee5e1a.jpeg",
    "https://cdn.faire.com/fastly/768b5be60e8b7e26e851b5c8a300125e9c89e5e1680d57685261861b19bd9026.jpeg",
    "https://cdn.faire.com/fastly/00b60970ee42953ce8620c834e63a80a0003c4509b73c16acf425ca4cbd0cab4.jpeg",
    "https://cdn.faire.com/fastly/a8e5a2c6370f3f50ad58da9c51954bf9133bf4f38c505b18354ad039b176c6b2.jpeg",
    "https://cdn.faire.com/fastly/bd94d1003d74f30f14a957b18c7563a9f1422e69fc59dd5bdf3f06a52ba9d65b.jpeg",
    "https://cdn.faire.com/fastly/b5bca76cff65e8c164592df6de7616cd767d3b23dca2321e0d781df81407eca7.jpeg",
    "https://cdn.faire.com/fastly/fa40a4dbf46d2432f0b3dde29066e2c079ce4c8b789b979b6ccbf06778b9059d.jpeg",
    "https://cdn.faire.com/fastly/e3d2f499803956d6ef9b92978aaa18f6ad6797100526679880351be642a8918a.jpeg",
    "https://cdn.faire.com/fastly/bbe0b6c33fdea71dd16021bec13160ca9cc6ccbf3c34880b511199291aa3fc1d.jpeg",
    "https://cdn.faire.com/fastly/83a8a12c09414603e1659bf4eedb188f7b0d7d6dd04db138a68ebeeba66a6dde.jpeg",
    "https://cdn.faire.com/fastly/39ba30b40d1c3f56fb2fc16f975068d79dcab5d31ffdb8ff5cf65d1d7663f62c.jpeg",
    "https://cdn.faire.com/fastly/9402c73e1fff0f69317c1266510777d6490c44797a0dc76b22d7f4e77ba44329.jpeg",
    "https://cdn.faire.com/fastly/c1f9d918658a54667d845c49fbcbb51205b72cce22f60492a76284c7bc0b613a.jpeg",
    "https://cdn.faire.com/fastly/9e0a843cf1e89dd67642a3cd3c268ed886b3db2b8b8472f447c23b520e12198c.jpeg",
    "https://cdn.faire.com/fastly/89a56934d0ce495c3f457785e6c081096821d81f2537722d1358f9493c8fec66.jpeg",
    "https://cdn.faire.com/fastly/729b865607216a9d96aeecfc61fd7f9b566818084fffd1ca05427139e3c87ff3.jpeg",
    "https://cdn.faire.com/fastly/98b120a289d9a76f7234bc0fa4b977262a9eea804d5b7cfde282395d1dd4e7c4.jpeg",
    "https://cdn.faire.com/fastly/fa35c5ac0bb21d52960ffc99ff61868fa2c3dcc9b6efc6d06597460eef5cb07a.jpeg",
    "https://cdn.faire.com/fastly/e78eec58536fcfc1286936b224621083dd7d9ea723b0790139f58a5b8dc0e558.jpeg",
    "https://cdn.faire.com/fastly/bbe57736c530eefc7358dbbbb89220a0881bf92e72cfde4d41f9bd2fd4c86473.jpeg",
    "https://cdn.faire.com/fastly/afe65c10e12cbf84a619e540a7370a622903df868949bd3f6a02daaf3a261328.jpeg",
    "https://cdn.faire.com/fastly/7037da8edd014de5990736638b11f19c58da73c8f1f4e63c96d6bff07eea501a.jpeg",
    "https://cdn.faire.com/fastly/752a986df6a7005406c14339765b8bc83ac414489568e04df0532b3c48ebde09.jpeg",
    "https://cdn.faire.com/fastly/61d75c19c5367ec9e07bd7dc81e3080b2d8ba0a1f31be4df8ecc92b65745df96.jpeg",
    "https://cdn.faire.com/fastly/bfe4cc1f25474be1e7da8f16789e615a31cb9bb104ca6ced606e6fda874c9f45.jpeg",
    "https://cdn.faire.com/fastly/22a4d2d1b95b73c5acc962b86d4834e233b8c3e342befc0486fce3805d51d3cc.jpeg",
    "https://cdn.faire.com/fastly/cc22e62e4cc64dbdf0941fa3d43363464836026a0ed294c3ec32f2dd2292920e.jpeg",
    "https://cdn.faire.com/fastly/2b1a9fa8583b6dfd9ed2471c309d4c976655c859b1eb7c44bedc458a3c1898d0.jpeg",
    "https://cdn.faire.com/fastly/40dca95f993ad8bfcff5fa1772f30ceabd9c61238360e322808d49ac68116be1.jpeg",
    "https://cdn.faire.com/fastly/da939bf2c2ee97cf1a54be9e18f5dd5965945a90643429da262a46665c05f3de.jpeg",
  ],
  priceDollars: 7,
  description:
    "Why We Made This?\n\nNoble x Le Bon Shoppe — A sock born from our shared love of intentional fashion, prismatic colors, and good design. The Petite Ruffled Modal Socks feature the same baby rib texture and playful lettuce-edge ruffle as the original, reimagined in a sweet, shortie length.\n\nMade in South Korea\n\n\n\n\nContents: \n\n80 modal 18 polyester 2 spandex\n\n\n\n\nSizing:\n\nOne size fits most (US women's size 6-10)\n\n\n\n\nCare Instructions:\n\nMachine wash cold\n\nTumble dry low\n\nDo not iron\n\nDo not bleach\n\n\n\n***Order in units of 6 (6,12,18,24 etc)\n\n\n\nMSRP: $15 USD\n",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:48.380Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
